import { DomainModel } from '@/models'
import { DomainViewModel } from '@/view-models'
import { TOKEN } from '@/utils'

/**
 * Manages A Domain Configuration Widget in the cart
 */
export class DomainConfigView {
  private widget: HTMLElement
  private model: DomainModel
  private viewModel: DomainViewModel

  constructor(
    widget: HTMLElement,
    model: DomainModel,
    viewModel: DomainViewModel
  ) {
    this.widget = widget
    this.model = model
    this.viewModel = viewModel

    const idProtectionWidget =
      this.widget.querySelector<HTMLElement>('.js-id-protection')
    const dnsManagementWidget =
      this.widget.querySelector<HTMLElement>('.js-dns-management')
    const emailForwardingWidget = this.widget.querySelector<HTMLElement>(
      '.js-email-forwarding'
    )
    const periodInput = this.widget.querySelector<HTMLSelectElement>(
      ".js-reg-period select[name^='period']"
    )
    const spotlightDomainWidget =
      this.widget.querySelector<HTMLElement>('.js-spotlight')

    if (!idProtectionWidget) {
      throw new Error('DomainConfigView: id protection el is null')
    }

    if (!dnsManagementWidget) {
      throw new Error('DomainConfigView: dnsManagement el is null')
    }

    if (!emailForwardingWidget) {
      throw new Error('DomainConfigView: emailForwarding el is null')
    }

    if (!periodInput) {
      throw new Error('DomainConfigView: period el is null')
    }

    if (!spotlightDomainWidget) {
      throw new Error('DomainConfigView: spotlight el is null')
    }

    this.onIdProtectionChange(idProtectionWidget)
    this.onDNSManagementChange(dnsManagementWidget)
    this.onEmailForwardingChange(emailForwardingWidget)
    this.onPeriodChange(periodInput)
    this.onAddSpotlightDomain(spotlightDomainWidget)
  }

  /**
   * Handles Change Id Protection
   * @param widget
   */
  onIdProtectionChange(widget: HTMLElement): void {
    widget.addEventListener('click', (event) => {
      event.preventDefault()
      const modelCopy = this.model.clone()
      modelCopy.setIdProtection(!this.model.idProtection)
      this.viewModel.addToCart(modelCopy)
      return
    })
  }

  /**
   * Handles Change DNS Management
   * @param widget
   */
  onDNSManagementChange(widget: HTMLElement): void {
    widget.addEventListener('click', (event) => {
      event.preventDefault()
      const modelCopy = this.model.clone()
      modelCopy.setDnsManagement(!this.model.dnsManagement)
      this.viewModel.addToCart(modelCopy)
      return
    })
  }

  /**
   * Handles Change Email Forwarding
   * @param widget
   */
  onEmailForwardingChange(widget: HTMLElement): void {
    widget.addEventListener('click', (event) => {
      event.preventDefault()
      const modelCopy = this.model.clone()
      modelCopy.setEmailForwarding(!this.model.emailForwarding)
      this.viewModel.addToCart(modelCopy)
      return
    })
  }

  /**
   * Handles Change Perios
   * @param widget
   */
  onPeriodChange(input: HTMLSelectElement): void {
    input.addEventListener('change', (e) => {
      e.preventDefault()
      const modelCopy = this.model.clone()
      const period = input.value
      modelCopy.setPeriod(Number.parseInt(period))
      this.viewModel.updatePeriod(modelCopy)
      return
    })
  }

  /**
   * Handles The Addition of spotlight domains in cart
   * @param widget
   */
  onAddSpotlightDomain(widget: HTMLElement): void {
    if (!TOKEN) {
      throw new Error("Add Spotlight Domain: Token isn't set")
    }
    const name = this.model.getName().split('.', 1).join('')
    const formData = new FormData()
    formData.append('a', 'checkDomain')
    formData.append('type', 'spotlight')
    formData.append('domain', name)
    formData.append('token', TOKEN)
    this.viewModel.checkDomain(formData).then(({ result }) => {
      result
        .filter(({ domainName }) => !this.viewModel.hasDomain(domainName))
        .forEach(({ isAvailable, tld }) => {
          if (isAvailable) {
            const button = widget.querySelector(`button[data-tld=".${tld}"]`)

            if (button) {
              button.classList.remove('hidden')
            }
          }
        })
    })

    const buttons = widget.querySelectorAll<HTMLButtonElement>('* > button')

    for (const button of buttons) {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        if (!TOKEN) {
          throw new Error("Add Spotlight Domain: Token isn't set")
        }
        const tld = button.dataset.tld ?? ''
        const domain = this.model.getName().split('.', 1).concat([tld]).join('')
        const addDomainFormData = new FormData()
        addDomainFormData.append('a', 'addToCart')
        addDomainFormData.append('domain', domain)
        addDomainFormData.append('token', TOKEN)
        this.viewModel.addToCartSingle(addDomainFormData).then((data) => {
          if (data.result === 'added') {
            location.reload()
          }
        })
      })
    }
  }
}
